var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 218.289,
    height: 189.938,
    viewBox: "0 0 218.289 189.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5353",
    "data-name": "Rectangle 5353",
    width: 146.599,
    height: 161.089,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10985",
    "data-name": "Group 10985",
    transform: "translate(-842.037 -693.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9796",
    "data-name": "Group 9796",
    transform: "translate(-125.963 124.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9797",
    "data-name": "Group 9797",
    transform: "translate(968 509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27838",
    "data-name": "Path 27838",
    d: "M37.246,374.64c.059-1.442,1.331-2.169,1.974-3.269a22.6,22.6,0,0,0,1.665-19.8c-1.1-3.07-.144-3.294,2.321-3.059a6.069,6.069,0,0,0,1.365-.178,3.141,3.141,0,0,1,2.531-.96c4.646-.018,9.3-.372,13.93.279a32.018,32.018,0,0,0,4.451.206c14.323.014,28.648.107,42.97-.058,4.024-.046,6.333,1.5,7.978,5.088a20.768,20.768,0,0,1-.942,20.267,7.118,7.118,0,0,1-6.627,3.759c-6.794.14-13.558-.454-20.338-.567-6.881-.116-13.768-.154-20.647.006-9.118.212-18.2-.887-27.312-.626a3.749,3.749,0,0,1-3.32-1.087",
    transform: "translate(-16.438 -153.262)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27839",
    "data-name": "Path 27839",
    d: "M34.137,371.2l59.686.9c4.463.067,8.928.055,13.387.23a3.509,3.509,0,0,0,3.4-1.8c6.007-8.852,4.161-16.642.143-23.869-.817-1.469-2.084-.992-3.19-1-13.112-.074-26.224-.028-39.335-.156-8.923-.087-17.843-.4-26.765-.609-1.623-.131-3.245-.283-4.87-.386-1.237-.079-2.541-.283-2.84-1.632-.339-1.528,1.076-1.88,2.143-2.359,4.485-.644,8.994-.186,13.49-.263,3.3-.057,6.595.06,9.827-.779,5.548.426,11.1.183,16.653.065a32.047,32.047,0,0,1,3.859.117c2.1.042,4.206.015,6.308.02,4.249.594,8.548.049,12.8.544,4.528-.25,9.06-.375,13.591-.476a2.654,2.654,0,0,1,.925.273c6.962,7.712,9.467,18.408,4.522,27.744-2.12,4-4.078,8.162-8.432,10.369-3.027.744-5.8-.918-8.816-.845-8.643.208-17.307.356-25.942.007-13.01-.527-26.018-.412-39.027-.52-1.747-.015-3.594.046-4.78-1.671-1.352-2.744-.864-3.327,3.261-3.9",
    transform: "translate(-13.329 -149.827)",
    fill: "#480e02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27842",
    "data-name": "Path 27842",
    d: "M17.546,403.249a33.269,33.269,0,0,0,6.625.526c21.738.246,43.475.545,65.214.737,2.516.022,4.787,1.68,7.365.88a9.8,9.8,0,0,1,6.175-.856c2.371.32,4.754.4,7.13.585,6.221.524,12.426,1.4,18.7.765,1.236.108,2.176.723,2.206,1.99.034,1.484,1.311,2.65.925,4.192-16.359.476-32.7-.57-49.063-.46-11.237.075-22.482-.221-33.714-.6q-16.963-.575-33.906-1.7A82.276,82.276,0,0,1,1.96,407.725c-.783-.182-1.962-.106-1.96-1.114,0-.991,1.18-.97,1.965-1.139a113.8,113.8,0,0,1,12.671-1.609c.99-.1,2.074.224,2.911-.614",
    transform: "translate(0 -177.973)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27847",
    "data-name": "Path 27847",
    d: "M63.92,310.326c-7.841.416-15.684.25-23.527.127.835-.88,1.92-.523,2.9-.53,4.919-.03,9.841-.1,14.756.038,2.346.066,2.971-.453,1.89-2.733a40.072,40.072,0,0,1-3.965-20.784,63.672,63.672,0,0,1,2.6-12.485c.6-2.06,2.239-2.575,4.118-2.595,2.784-.031,5.568,0,8.352.009a3.127,3.127,0,0,1,.085,2.463c-.236.495-.452,1.024-1.169.874-2.242-.678-4.543-.051-6.333-.283,1.635.05,3.744-.1,5.851.06a1.96,1.96,0,0,1,.655.448,1.892,1.892,0,0,1,.207.786,10.823,10.823,0,0,1-.48,2.028A10.129,10.129,0,0,0,69.488,279c-2.217,8.051-2.894,16.088.109,24.114a5.418,5.418,0,0,1,.41,2.175c-.989,3.392-3.809,1.56-5.5,2.063,2.037.342,4.5-.534,6.818.553,1.3,2.154,1.28,2.175-1.042,2.263a46.841,46.841,0,0,0-6.366.163",
    transform: "translate(-17.827 -119.761)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27848",
    "data-name": "Path 27848",
    d: "M316.9,379.7l-6.124-.3c-1.1-1.926.3-3.35,1.026-4.875a29.119,29.119,0,0,0,2.305-19.778,10.2,10.2,0,0,0-2.069-4.52,3.809,3.809,0,0,1-.554-4.383c.53-1.093.241-2.684,1.872-3.114.108.51-.046,1.165.69,1.337.267.063.552.043.827.079,2.883.385,6.446-.992,8.517,1.383a28.066,28.066,0,0,1,5.819,12.464,21.866,21.866,0,0,1,.442,7.18c-.155,1.428-2.692,11.251-4.438,13.854-.363,1.3-5.36.758-8.313.674",
    transform: "translate(-136.98 -151.261)",
    fill: "#b61b15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27856",
    "data-name": "Path 27856",
    d: "M250.129,271.514q.1-.51.195-1.019c.527,3.316,2.693,3.125,5.113,2.392,2.84.183,4.408,2.348,6.217,4.081.782.749.412,1.508-.548,1.948a14.7,14.7,0,0,1-6.344.337c-6.283-.782-12.581-.461-18.87-.441-8.428.027-16.826-.684-25.243-.806a20.863,20.863,0,0,0-4.875-.7c-2.092-.109-2.7-1.09-1.758-2.87.492-.93.651-2.061,1.51-2.8,9.632.055,19.256-.371,28.892.331,5.211.38,10.505.729,15.71-.457",
    transform: "translate(-89.852 -119.382)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27872",
    "data-name": "Path 27872",
    d: "M116.433,268.513c-.168,1.381.617,1.628,1.746,1.469,5.811-.36,11.629-.042,17.442-.172,1.942-.044,2.127,1,1.755,2.506a3.493,3.493,0,0,1-.771,1.845,1.4,1.4,0,0,1-1.294.552,2.565,2.565,0,0,1-.82-.484,5.669,5.669,0,0,0-3.213-.509c-4.314-.013-8.628.01-12.943-.015a5.139,5.139,0,0,1-2.933-.508c-1.559-1.028-.823-2.77-1.274-4.146l2.305-.538",
    transform: "translate(-50.37 -118.507)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27885",
    "data-name": "Path 27885",
    d: "M105.314,269.476c1.956.739,1.337,2.027.709,3.318a.679.679,0,0,1-.137.715c-3.956.594-7.9.95-11.71-.741a3.939,3.939,0,0,1,.6-2.221c3.457-.913,7.071-.288,10.542-1.07",
    transform: "translate(-41.557 -118.932)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27950",
    "data-name": "Path 27950",
    d: "M49.936,367.159a4.049,4.049,0,0,1,3.293-.871q28.171-.005,56.341.03a10.027,10.027,0,0,1,1.115.012c.681.078,1.771-.217,1.711.845-.056,1-1.134.743-1.823.744-16.456.012-32.914.151-49.366-.117a84.962,84.962,0,0,1-11.271-.642",
    transform: "translate(-22.039 -161.647)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27951",
    "data-name": "Path 27951",
    d: "M110.246,386.215c-20.742.67-41.467.135-62.18-1.123,20.744-.916,41.456.4,62.18,1.123",
    transform: "translate(-21.214 -169.821)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27952",
    "data-name": "Path 27952",
    d: "M96.931,374.58c-14.966.274-29.949,1.161-44.892-.532,14.977-1.215,29.927.284,44.892.532",
    transform: "translate(-22.967 -164.878)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27953",
    "data-name": "Path 27953",
    d: "M48.09,357.858c11.986-.868,23.952-.206,35.916.691a226.934,226.934,0,0,1-35.916-.691",
    transform: "translate(-21.224 -157.761)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27954",
    "data-name": "Path 27954",
    d: "M186.631,377.85l-13.447-.5a34.957,34.957,0,0,0,8.425-13.512c2.4-7.308.453-13.825-3.341-20.069-.619-1.018-1.2-2.058-1.805-3.087a1.6,1.6,0,0,1,1.349-.85c3.747.106,7.528-.569,11.24.434,4.2,4.553,5.917,9.97,6.377,16.125.581,7.773-2.521,14.028-6.843,20a3.662,3.662,0,0,1-1.955,1.465",
    transform: "translate(-76.434 -149.928)",
    fill: "#b61b15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27955",
    "data-name": "Path 27955",
    d: "M87.989,308.249c-3.869-9.025-3.517-18.137-.562-27.3,1.659-.925,2.52-.147,3.018,1.409-1.423,3.345-1.094,3.959,2.694,4.106,1.335.052,3.164.886,3.85-1.317-.532,1.446-1.713,1.422-2.931,1.387-1.3-.039-2.729.051-3.671-.884-1.305-1.295.645-2.246.66-3.457a2.2,2.2,0,0,1,1.8-.926,10.555,10.555,0,0,1,2.184-.087c2.081.412,3.068-.636,3.5-2.5,1.6-1.6,2.1-.451,2.478.989.066,2.888-.687,5.689-1.1,8.512-1.017,7,.159,13.636,2.513,20.163a20.043,20.043,0,0,1,.88,3.124,2.74,2.74,0,0,1,.162.751,1.509,1.509,0,0,1-.4,1.035L82.5,313.215c2.141-.749,4.348-.234,6.52-.324,2.152-.089,1.133-.946.522-1.762a.587.587,0,0,1,.033-.708c1.941-.6,3.718.992,5.693.4.853-.255,1.88.026,2.466-.928,1.29-1.681-.116-2.1-1.244-2.351a33.422,33.422,0,0,0-4.344-.2c-1.667-.147-.6,1.4-1.156,1.947-.53.7-1.416.534-2.1.869-1.137-.241-.4-1.368-.906-1.911",
    transform: "translate(-36.412 -122.649)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27956",
    "data-name": "Path 27956",
    d: "M138.007,339.487a94.317,94.317,0,0,1-12.817-.431c-1.2-.676-2.5-.213-3.746-.318-.9-.075-1.87.146-2.447-.838l-.02.024c-.516-1.106.172-1.475,1.058-1.669a7.767,7.767,0,0,1,2.7-.115c3.47.733,6.984.2,10.472.368,1.365.065,2.779-.222,4.055.536a2.5,2.5,0,0,1,.975,1.085,1.244,1.244,0,0,1-.23,1.357",
    transform: "translate(-52.432 -148.325)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27957",
    "data-name": "Path 27957",
    d: "M153.179,339.008q0-.515,0-1.031c.1-2.174,1.659-2.416,3.328-2.514,2.775-.164,5.566.3,8.328-.208a2.3,2.3,0,0,1,.727-.266c.925.117,1.134.9,1.474,1.573a2,2,0,0,1,.06,1.779,51.438,51.438,0,0,1-13.915.668",
    transform: "translate(-67.604 -147.846)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27958",
    "data-name": "Path 27958",
    d: "M177.638,338.708l-.572-1.432c.571-2,2.187-1.251,3.378-1.127a31.024,31.024,0,0,0,8.824-.1,3.567,3.567,0,0,1,1.692-.178,1.983,1.983,0,0,1,.818,2.838,1.668,1.668,0,0,1-.632.5l-12.968-.236-.54-.258",
    transform: "translate(-78.148 -148.213)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27959",
    "data-name": "Path 27959",
    d: "M119.153,339.344c1.9,1.25,4.319-.249,6.194,1.156a24.781,24.781,0,0,1-6.1-.132l-.092-1.024",
    transform: "translate(-52.588 -149.769)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27960",
    "data-name": "Path 27960",
    d: "M197.255,377.28c2.846-4.3,6.283-8.512,7.348-13.509a27.437,27.437,0,0,0-1.559-17.458,12.56,12.56,0,0,0-2.841-4.478c-.615-.532-.24-.983-.147-1.489a3.157,3.157,0,0,1-.021-.349,5.792,5.792,0,0,1,3.759-1.561c3.159,0,6.319-.065,9.478.03a8.051,8.051,0,0,1,4.466,1.364c2.523,1.435,3.126,3.959,3.83,6.509,1.285,4.657,2.513,9.265,2.339,14.2a22.127,22.127,0,0,1-2.317,9.628,4.037,4.037,0,0,0-.507,2.909,5.042,5.042,0,0,1-3.187,4.432c-.609-.023-1.241-.132-1.688.45a54.738,54.738,0,0,1-18.951-.679",
    transform: "translate(-87.058 -149.358)",
    fill: "#a01612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27969",
    "data-name": "Path 27969",
    d: "M284.832,354.483a10.251,10.251,0,0,1,6.55-3.486c1.765-.143,2.618-1.883,4-2.727-.989,1.632-.3,2.7.7,4.245,3.165,4.92,3,10.489,2.359,16.112-.552,4.81-3.263,8.774-4.725,13.215-4.853.851-9.771.818-14.669,1.044-.479.022-.981-.429-1.472-.66-.434-1.154.188-2.173.45-3.223,1.3-5.193,2.742-10.36,2.466-16.491-2.158,2.412-3.553,4.748-5.437,6.643-.82.825-1.409,2.043-2.911,1.716-.86-.815-.234-1.6.193-2.218a150.023,150.023,0,0,1,11-13.553,1.761,1.761,0,0,1,1.492-.617",
    transform: "translate(-119.92 -153.708)",
    fill: "#a01612"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27971",
    "data-name": "Path 27971",
    d: "M256.279,391.82c2.384-4.275,6.139-7.493,8.871-11.5,2.536-1.329,3.932-3.773,5.528-5.943,1.039-1.412,2.241-2.56,3.639-4.153a25.352,25.352,0,0,1-.3,10.279c-.8,3.868-1.227,7.88-3.251,11.413l-14.483-.1",
    transform: "translate(-113.108 -163.398)",
    fill: "#b51c15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27972",
    "data-name": "Path 27972",
    d: "M104.957,278.715c-.105-.473.118-1.156-.5-1.323-.6-.161-.539.507-.715.855a2.722,2.722,0,0,1-2.16.078c-1.766-1.011-3.733.03-5.542-.538a.891.891,0,0,1-.19-1.237c-.693.693-.023,2.1-1.366,2.31-.925-.246-.673-1.3-1.229-1.8-.021-.2-.042-.4-.063-.594l.006-.013.552-1.088,11.634.515a1.452,1.452,0,0,1,.749,1.151c-.051.8-.019,1.656-1.175,1.68",
    transform: "translate(-41.13 -121.533)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27973",
    "data-name": "Path 27973",
    d: "M85.644,276.415c-2.789,1.134-5.694.384-8.543.512a.876.876,0,0,1-1.011-.746.991.991,0,0,1,.656-.722c2.854-.109,5.722-.522,8.547.218.17.045.24.474.356.725l-.006.013",
    transform: "translate(-33.582 -121.479)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27974",
    "data-name": "Path 27974",
    d: "M85.949,332.228l1.065,1.721a.961.961,0,0,1,.512.575c-.007.194-.014.388-.021.583-3.2-.351-6.548.627-9.624-1.054,1.82-.982,3.745-.519,5.606-.656.975-.072,2.146.285,2.462-1.169",
    transform: "translate(-34.373 -146.628)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27975",
    "data-name": "Path 27975",
    d: "M92.427,278.4c1.087.09,1.008.955,1.122,1.69.878,1.136,3,.268,3.426,2.128-.719.078-1.468.089-1.882.846a.887.887,0,0,1-1.034-.207,2.672,2.672,0,0,0-2.744-1.69l.326-.6a1.485,1.485,0,0,0,.633-1.7.977.977,0,0,1,.151-.466",
    transform: "translate(-40.302 -122.872)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27976",
    "data-name": "Path 27976",
    d: "M92.534,279.237c1.07,1.043.174,1.355-.633,1.7a2.646,2.646,0,0,1,.633-1.7",
    transform: "translate(-40.56 -123.24)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27981",
    "data-name": "Path 27981",
    d: "M250.579,308.41a17.869,17.869,0,0,0-2.482,4.407,3.6,3.6,0,0,1-3.309,1.025c-4.764-.57-9.567-.313-14.336-.748a17.025,17.025,0,0,0-4.952-.585q-11.844.046-23.688.006c-3.961-.012-4.706-.654-5.988-4.436a31.758,31.758,0,0,1,.005-21.3c1.655-4.7,2.1-4.973,6.954-4.947a7.989,7.989,0,0,1,3.032.2l51.754,1.041a.253.253,0,0,1,.17.2,2.194,2.194,0,0,1,.031,2.589,29.112,29.112,0,0,0-3.144,18.208,2.823,2.823,0,0,1-.77,2.551.524.524,0,0,1-.483.135c-8.25.621-16.477-.433-23.055-.153,4.619.008,10.9.156,17.188.362,1.182.039,2.727-.471,3.073,1.442",
    transform: "translate(-85.616 -124.366)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27982",
    "data-name": "Path 27982",
    d: "M195.309,277.769c-.741.029-1.483.085-2.225.083-4.847-.008-4.861-.018-6.59,4.454-3.081,7.966-2.4,15.827.594,23.66.577,1.509,1.61,1.521,2.867,1.52q13.391-.015,26.781.027a7.334,7.334,0,0,1,3.294.385c-.9,1.212-2.247,1.188-3.535,1.2-8.343.052-16.687,0-25.031-.007a4.546,4.546,0,0,1-3.356-1.055l-1.135.516c-2.166-.68-4.383-.116-6.572-.265a28.937,28.937,0,0,1-7.554-1.218c-1.295-.729-1.556-2.049-1.774-3.318-1.554-9.057-1.316-17.943,2.666-26.446.659-.784.641-2.1,1.875-2.44,2.539.967,5.2.183,7.464.489-2.071-.475-4.669.788-6.938-.82-.316-1.477-.041-2.513,1.781-2.39,4.126.289,8.284.079,12.385.774,1.46,1.118.061,1.934-.4,2.692-.751,1.221-.464,1.57.856,1.68,1.518.127,3.118-.446,4.551.483",
    transform: "translate(-75.11 -120.104)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27984",
    "data-name": "Path 27984",
    d: "M156.38,271.356c-1.135.357-1.412,1.322-1.644,2.318a1.777,1.777,0,0,1-.964.4c-4.707.528-9.417,1.222-14.068-.368.738-2.188.154-2.955-2.325-2.873-5.329.178-10.67-.006-16-.041a4.123,4.123,0,0,1,2.433-.33q13.6-.07,27.192-.111a11.658,11.658,0,0,1,5.379,1",
    transform: "translate(-53.569 -119.32)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27986",
    "data-name": "Path 27986",
    d: "M202.251,336.289l31.922-.134,17.562.657c-.28,1.217-.063,2.565-.952,3.62a7.932,7.932,0,0,1-4.6.758,94.885,94.885,0,0,0-13.085-.034c-4.354-.288-8.759-.1-13.025-1.291a8.735,8.735,0,0,0-5.5-1.358c-4.116.092-8.254-.365-12.339.495.7-.9.066-1.808.022-2.712",
    transform: "translate(-89.253 -148.361)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27987",
    "data-name": "Path 27987",
    d: "M274.877,327.156c-.626-.749-1.5-.626-2.325-.645-6.959-.158-13.9-.784-20.874-.546a1.789,1.789,0,0,1-.279,0c-.874-.106-2.395.289-2.357-.773.049-1.353,1.622-.838,2.533-.816,2.313.056,4.619.38,6.931.42,5.02.084,10.042.078,15.063.062a11.326,11.326,0,0,1,4.1.648l-2.794,1.651",
    transform: "translate(-109.914 -143.112)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27989",
    "data-name": "Path 27989",
    d: "M274.988,344.385l-1.084.606c-.5.782-1.209,1.412-1.659,2.233-1.225.636-1.392,2.323-2.78,2.8-.846-1.425.373-3.468-1.25-4.6-1.526-1.065-3.272.213-4.852-.172-2.077-.506-4.649.534-6.149-1.865,5.947-.046,11.894-.18,17.836.212-.021.264-.042.526-.063.789",
    transform: "translate(-113.521 -151.525)",
    fill: "#9f1b15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27994",
    "data-name": "Path 27994",
    d: "M112.9,279.5c.546-.447.487-1.1.57-1.7.351-.123-.141-.129.223-.158a93.488,93.488,0,0,1,20.384.134q.025.335.051.67c.866,1.127.453,2.341.084,3.452-2.4,7.245-2.218,14.569-.88,21.965.306,1.693.921,3.452-.076,5.157a2.925,2.925,0,0,1-2.507.906c-4.528.022-9.057-.041-13.586.034a4.25,4.25,0,0,1-2.568-.893,36.666,36.666,0,0,1-3.2-19.44c.349-3.391.992-6.752,1.5-10.127",
    transform: "translate(-49.074 -122.321)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27995",
    "data-name": "Path 27995",
    d: "M148.866,308.752c-.571-4.022-1.246-8.032-1.688-12.067-.682-6.219,1.088-12.1,2.767-17.976l.576-.576c4.11-.7,8.249-.25,12.374-.253.98,0,2.1.387,1.58,1.889a43.819,43.819,0,0,0-2.247,28.013,12.532,12.532,0,0,0,.576,1.551q.266.2.164.388c-.065.12-.13.18-.193.18l-.061.05c-2.846.534-5.718.163-8.577.21a6.748,6.748,0,0,0-3.949,1.034,1.167,1.167,0,0,1-.851-.015c-.906-.664-.255-1.629-.468-2.427",
    transform: "translate(-64.89 -122.58)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27996",
    "data-name": "Path 27996",
    d: "M167.233,279.159c-.394-1.593-1.7-1.065-2.717-1.14-3.74-.275-7.528.518-11.237-.5q.253-.582.505-1.164l14.61.061a.4.4,0,0,1-.055.538l-1.106,2.2",
    transform: "translate(-67.649 -121.97)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27997",
    "data-name": "Path 27997",
    d: "M135.764,277.013l-20.607.025q-.071-.566-.142-1.133.108-.244.213-.488c5.9,1.067,11.852.226,17.772.53.993.051,2.349-.581,2.764,1.067",
    transform: "translate(-50.762 -121.554)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28005",
    "data-name": "Path 28005",
    d: "M135.739,333.253c.6.661.4,1.5.5,2.27a77.931,77.931,0,0,1-14.526.013c-1.09.515-2.75-.67-3.406,1.142q-.513-1.425-1.024-2.85c5.282.011,10.564.028,15.845.025.905,0,1.879.2,2.608-.6",
    transform: "translate(-51.764 -147.08)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28006",
    "data-name": "Path 28006",
    d: "M94.741,333.626l-.512-.575c.18-1.363.982-.836,1.7-.559,1.173-2.492,3.325-2.547,5.544-2.059,1.15.254,2.3.854,1.764,2.474.065.977.682,1.813-1.36,1.8a17.221,17.221,0,0,1-7.135-1.077",
    transform: "translate(-41.588 -145.729)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28007",
    "data-name": "Path 28007",
    d: "M93.96,310.636a.905.905,0,0,0,.53,1.349c.753.336,1.249-.065,1.623-.659a3.607,3.607,0,0,1,3.665-2.032,2.44,2.44,0,0,1,2.259,2.131,1.827,1.827,0,0,1-1.1,2.051,1.514,1.514,0,0,1-1.044.1c-.448-.144-.422-.6-.173-.9.556-.675,1.289-1.4.013-1.945-1.077-.457-1.651.489-2.252,1.2-1.74,2.06-3.311,2.2-4.765.484a2.069,2.069,0,0,1-.495-2.06c.2-.653.545-1.244,1.355-1.129,1.126.16.684.822.387,1.412",
    transform: "translate(-40.658 -136.469)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28008",
    "data-name": "Path 28008",
    d: "M94.917,286.381l1.034.207c3.2,2.145-1.559.887-.55,2.411a11.28,11.28,0,0,0,5.345.506c.634-1.351-1.508-.994-1.131-2.268,1.447-.246,2.882-.132,3.106,1.624.261,2.044-1.412,2.052-2.839,2.032a29.9,29.9,0,0,1-3.877-.235c-1.08-.156-2.318-.342-2.67-1.636-.364-1.337.656-1.995,1.582-2.641",
    transform: "translate(-41.16 -126.393)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28009",
    "data-name": "Path 28009",
    d: "M98.739,281.646c-1.068-.828-3.32.249-3.426-2.128.163-.52.348-1.034.481-1.561.12-.473.294-.98.848-.829s.342.778.436,1.207c.3.205.642.625.927.5,1.764-.754,3.45-.12,5.159.178a.95.95,0,0,1,1.514,0c-.039,2.35-1.169,3.233-3.49,2.72a13.02,13.02,0,0,0-2.449-.085",
    transform: "translate(-42.066 -122.298)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28010",
    "data-name": "Path 28010",
    d: "M103.921,331.857c-1.5-2.49-4.227-2.709-6.084-.479-.4.484-.808.187-1.223.065-.163-.526-.358-1.045-.48-1.581-.136-.6-.655-1.273-.113-1.818.7-.709,1.045.439,1.622.468,1.465.074,2.935.069,4.4.176a3.273,3.273,0,0,1,3.211,2.2c.364,1.178.066,1.951-1.33.974",
    transform: "translate(-42.272 -144.679)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28011",
    "data-name": "Path 28011",
    d: "M102.283,320.133c1.441.164,3.063.473,2.889,2.259s-1.9,1.753-3.308,1.732c-1.164-.016-2.411.13-3.478-1.089,1.62-1.328,3.749.842,5.154-.846-.49-1.146-1.853-.628-2.59-1.31.154-.5.579-.6,1.013-.683l.32-.063",
    transform: "translate(-43.422 -141.29)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28012",
    "data-name": "Path 28012",
    d: "M93.192,304.2c-2.1-.222-.711-1.811-1.032-2.725-.131-.374-.033-1.111.561-.988.42.087.732.7,1.092,1.08.923.527,2.005-.036,2.937.427,1.53.126,3.179-.353,4.9.917-1.929.782-3.511.284-5.071.207-1.3-.18-2.783-.914-3.392,1.082",
    transform: "translate(-40.605 -132.612)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28013",
    "data-name": "Path 28013",
    d: "M96.936,296.916a8.612,8.612,0,0,1,6.363.288c-2.123.412-4.244.785-6.363-.288",
    transform: "translate(-42.782 -130.837)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28014",
    "data-name": "Path 28014",
    d: "M97.319,320.314a4.5,4.5,0,0,1-3.7-.83,11.037,11.037,0,0,1,6.561.18l-.182.205c-.84.469-1.86-.151-2.678.445",
    transform: "translate(-41.318 -140.821)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28015",
    "data-name": "Path 28015",
    d: "M94.131,305.883c.45-1.842.689-1.918,3.392-1.082-1.185.191-2.593-.319-3.392,1.082",
    transform: "translate(-41.544 -134.297)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28016",
    "data-name": "Path 28016",
    d: "M98.179,302.858c-1.008.054-2.055.376-2.938-.427a6.291,6.291,0,0,1,2.938.427",
    transform: "translate(-42.034 -133.477)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28017",
    "data-name": "Path 28017",
    d: "M100.243,320.877c.784-.806,1.76-.456,2.679-.445l-1.153.541-1.527-.1",
    transform: "translate(-44.242 -141.384)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28018",
    "data-name": "Path 28018",
    d: "M151.937,336.043c.131-.59-.1-1.513.792-1.543,4.027-.137,8.078-.848,12.065.355.268,1.49-.7,1.351-1.669,1.31-2.281-.1-4.569-.087-6.845-.255a3.662,3.662,0,0,0-3.736,1.705l-.544-.566a.678.678,0,0,1-.063-1.006",
    transform: "translate(-66.972 -147.483)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28019",
    "data-name": "Path 28019",
    d: "M140.228,337.433q.032.5.063,1.006c-3.727-1.174-7.556-.262-11.325-.57-1.258-.1-2.616.43-3.751-.539l14.526-.013q.242.064.487.116",
    transform: "translate(-55.263 -148.874)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28020",
    "data-name": "Path 28020",
    d: "M175.212,334.856c.009-.189.02-.378.029-.568,4.19-.1,8.351,1.285,12.565.215,1.226-.312,1.329.6,1.387,1.475-2.953,1.128-6,.49-9,.393a9.866,9.866,0,0,0-3.943.226l-1.036-1.741",
    transform: "translate(-77.329 -147.535)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28021",
    "data-name": "Path 28021",
    d: "M247.042,343.022a22.119,22.119,0,0,0,7.569.941c1.511-.125,3.271-1.209,4.394.191a4.305,4.305,0,0,1,.288,5.506q-5.931,6.626-11.858,13.256c-3.506,3.946-6.981,7.919-10.47,11.88-.6.2-.968.361-.867-.649.175-1.759,1.427-2.988,1.941-4.575,1.994-6.15,1.479-12.234-.278-18.314a35.389,35.389,0,0,1-1.592-6.685c-.084-.947-2.037-.492-2-1.906a74.592,74.592,0,0,1,12.875.356",
    transform: "translate(-103.349 -151.163)",
    fill: "#b61b15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28022",
    "data-name": "Path 28022",
    d: "M284.107,348.541c-.144-1.263.681-1.8,1.659-2.233l-.536,1.679-1.123.554",
    transform: "translate(-125.383 -152.842)",
    fill: "#81170a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28023",
    "data-name": "Path 28023",
    d: "M104.481,279.433c-.089,1.089-1,2.228-1.6,1.188-1.059-1.847-1.535-.755-2.611-.278-1.048.463-2.347.235-1.878-1.59,2.108-.478,4.288-1.609,6.087.68",
    transform: "translate(-43.382 -122.716)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28024",
    "data-name": "Path 28024",
    d: "M262.448,293.293c-.454,1.075-1.087.894-1.59.9q-18.11.106-36.187-1.023c-3.059-.195-6.137-.075-9.205-.132-.613-.012-1.518.04-1.445-.851.068-.832.959-.751,1.585-.718,13.448.715,26.91.943,40.373,1.12,2.1.027,4.2.45,6.468.708",
    transform: "translate(-94.456 -128.629)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28025",
    "data-name": "Path 28025",
    d: "M258.7,315.849c-15.924,1.22-31.852-.381-47.778-.157q0-.384-.006-.768h47.713q.035.463.071.925",
    transform: "translate(-93.085 -138.991)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28026",
    "data-name": "Path 28026",
    d: "M233.977,306.831c11.616-.392,23.236-.917,34.822.77-11.614.435-23.227.719-34.822-.77",
    transform: "translate(-103.265 -135.244)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28027",
    "data-name": "Path 28027",
    d: "M180.237,276.931a4.572,4.572,0,0,0,.055-.538c.14-.036.282-.068.423-.1,2.78.01,5.559.011,8.339.038.627.006,1.484-.08,1.521.791.038.9-.816.854-1.446.859-2.5.018-5,0-7.5,0a1.214,1.214,0,0,1-1.387-1.057",
    transform: "translate(-79.547 -121.943)",
    fill: "#e6e7eb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9795",
    "data-name": "Group 9795",
    transform: "translate(917.484 693.285) rotate(13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9794",
    "data-name": "Group 9794",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28029",
    "data-name": "Path 28029",
    d: "M267.683,22.515c-1.134-6.3-2.983-12.287-7.519-17.087A14.889,14.889,0,0,0,252.716.995a7.551,7.551,0,0,0-3.57.021c.175.825.827.923,1.327,1.152C258.6,5.905,262.59,12.676,264.3,21.086a23.807,23.807,0,0,1,.8,5.4c-.03,1.054.123,2.134-1.476,2.2-1.483.06-1.963-.774-2.072-2.014a39.925,39.925,0,0,0-1.42-8.06c-1.87-6.2-5.251-11.03-11.952-12.693a14.529,14.529,0,0,0-7.916.314,33.386,33.386,0,0,0-16.509,11.283,10.6,10.6,0,0,1-1.283,1.459c-4.257,5.158-7.245,11.067-10.114,17.049-2.11,4.4-3.637,9.024-5.383,13.565-.682.354.008,1.121-.462,1.539v0c-.568.72-.482,1.638-.743,2.451-1.022,4.837-2.344,9.611-3,14.524-1.365,10.15-1.661,20.267,1.1,30.255a30.279,30.279,0,0,0,4.38,9.548c5.568,7.864,13.871,8.919,21.987,5.048,4.233-2.02,7.7-5.075,11.184-8.12,4.666-3.514,7.6-8.452,10.726-13.2,3.619-5.492,6.187-11.54,8.909-17.5a146.73,146.73,0,0,0,5.344-17.259A114.109,114.109,0,0,0,268.5,45c.237-2.584.461-5.166.718-7.746.408-4.093-.242-8.148-.578-12.211a7.8,7.8,0,0,0-.954-2.529",
    transform: "translate(-201.748 -0.481)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28030",
    "data-name": "Path 28030",
    d: "M16.72,199.469q.005,1.182.01,2.365c.631.955,1.377.3,2.066.125,1.235-.315,2.266-1.289,3.65-1.133,1.31.361,1.36,1.522,1.422,2.511a62.719,62.719,0,0,1-.039,10.112c-.147,1.484-.121,2.985-.4,4.455a3.228,3.228,0,0,1-.93,2.084,7.992,7.992,0,0,1-4.528,2.024c-.752.118-1.585.03-2.068.823-1.109,6-3.761,11.419-6.326,16.874a15.44,15.44,0,0,0-.639,2.016,1.247,1.247,0,0,0,1.279.8c2.639-.719,5.464-.786,7.906-2.219a31.167,31.167,0,0,0,2.8-5.783c1.655-3.826,3.216-7.688,4.6-11.623,2.619-7.423,2.294-15.125,2.316-22.8,0-1.08-.273-2.236.541-3.182,1-.825,1.788.11,2.645.337a10.132,10.132,0,0,1,2.068.97c3.715,1.616,7.5,3.076,11.17,4.79.35.163.937.064.987.688.907,1.105,1.871.7,2.842.109,2.321-.52,4.025-2.045,5.714-3.569a6.9,6.9,0,0,1,2-1.489,33.972,33.972,0,0,0,8.129-27.243,6.144,6.144,0,0,1-1.107-2.225,11.251,11.251,0,0,0-7.277-7.777c-6.658-2.437-13.187-5.227-19.773-7.86-.722-.289-1.465-.526-2.2-.787-.824-.18-1.663-.569-2.42.173-.482.746-.039,1.366.307,1.974a16.506,16.506,0,0,1,1.637,3.929,33.7,33.7,0,0,1-.8,17.852,38.6,38.6,0,0,1-4.715,9.586,22.783,22.783,0,0,1-11.506,9.15,5.4,5.4,0,0,1-1.412.315,2.136,2.136,0,0,0-1.8.862c1.25.951,3.065,1.116,3.824,2.749,2.667-.906,5.462-1.358,8.124-2.284-2.647.97-5.454,1.376-8.112,2.3",
    transform: "translate(78.851 -92.841)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28031",
    "data-name": "Path 28031",
    d: "M60.761,264.232c-1.341-.087-1.192.858-1.19,1.709,0,3.58.059,7.162-.006,10.74a48.491,48.491,0,0,1-4.238,19.2c-1.806,4.023-3.441,8.122-5.152,12.187a1.159,1.159,0,0,0,.852.793A97.67,97.67,0,0,1,64.7,313.924c1.91.824,3.733,1.814,5.56,2.8.724.226,1.372.937,2.225.359,1.688-3.426,2.04-7.2,2.711-10.868,1.985-10.861,3.361-21.809,4.36-32.8a2.691,2.691,0,0,1,.836-1.685c-.979.179-1.962.383-2.808-.393-2.466-1.577-5.27-2.4-7.93-3.549-1.364-.587-2.743-1.141-4.091-1.765-1.6-.594-3.059-1.575-4.8-1.788",
    transform: "translate(46.56 -160.759)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28032",
    "data-name": "Path 28032",
    d: "M96.8,71.128l.05-.156a11.675,11.675,0,0,0-1.327-1.727l-1.253-1.916c-1.647.112-.994,1.353-.951,2.141a100.589,100.589,0,0,1-.341,16.392c-.021.191-.079.382-.112.573a2.043,2.043,0,0,0,.13.963c1.057.063,1.1,1.113,1.588,1.706a109.337,109.337,0,0,0,17.567,17.079c5.626,4.41,12.078,7.1,18.356,10.2a3.083,3.083,0,0,0,2.093.317c.95-.247,1.45.347,2.064.8a.994.994,0,0,0,.521-.778c.317-4.67.491-9.318-2.1-13.543a8.412,8.412,0,0,0-3.742-3.533c-1.563-.5-2.708-1.8-4.283-2.287-2.031-.852-3.6-2.4-5.428-3.571a55.147,55.147,0,0,1-5.954-4.632,56.534,56.534,0,0,1-8.66-8.064c-.726-.82-1.466-1.636-2.2-2.458a28.072,28.072,0,0,0-3.171-3.953A21.966,21.966,0,0,0,96.8,71.128",
    transform: "translate(-25.12 -40.964)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28033",
    "data-name": "Path 28033",
    d: "M102.159,386.065l-1.981-.734c-2.938-1.168-5.72-2.7-8.658-3.852a74.9,74.9,0,0,0-10.979-3.8c-2.032-.333-3.854.577-5.763.969-.907.186-1.752.8-2.744.4l-1.128-.416c-1.174,1.947-.284,3.473,1.248,4.535,5.017,3.474,10.445,6.316,16.437,7.423a17.868,17.868,0,0,0,11.535-2.093c.943-.5,1.942-1.127,2.032-2.424",
    transform: "translate(16.886 -229.739)",
    fill: "#c6453a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28034",
    "data-name": "Path 28034",
    d: "M211.295,18.491c1.913-.961,2.954-2.864,4.445-4.271a34.34,34.34,0,0,1,13.09-7.866C233.185,4.939,239.37,5.24,243.7,9.8c4.166,4.38,5.265,9.672,6.032,15.238.071.513.05,1.042.148,1.549A2.757,2.757,0,0,0,253.8,28.7a.939.939,0,0,0,.639-1.058c-.05-9.76-4.05-22.028-15.452-26.687a.8.8,0,0,1-.535-.439h3.1a16.089,16.089,0,0,0-10.1.75c-7.186,2.573-12.427,7.715-17.274,13.327-1.051,1.217-2.3,2.317-2.87,3.9",
    transform: "translate(-190.576 0)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28035",
    "data-name": "Path 28035",
    d: "M104.092,146.387c3.172,1.658,4.734,4.45,5.442,7.811a23.457,23.457,0,0,1,.11,9.774c-.588.45-.535,1.148-.666,1.766a37.738,37.738,0,0,1-3.211,9.348,27.124,27.124,0,0,1-8.09,10.364,10.289,10.289,0,0,1-6.9,2.243,14.479,14.479,0,0,0-4.473.181c-.394.211-.663.487-.5.981a11.273,11.273,0,0,0,3.094,1.513,30.7,30.7,0,0,0,5.031.529c.435.014.89.087,1.184-.362,8.076-3.052,12.662-9.319,15.73-17.014a33.218,33.218,0,0,0,1.914-18.833,2.64,2.64,0,0,1-.044-1.346c-.269-2.048-1.581-3.645-2.362-5.472-.166-1.11-1.248-1.381-1.887-2.056l-.822-.321a4.374,4.374,0,0,1-2.688-1.206,4.2,4.2,0,0,0-2.463-.59c-.385.157-1.02-.186-1.145.436-.084.423.4.571.7.816.643.539,1.493.777,2.043,1.438",
    transform: "translate(-0.335 -87.426)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28036",
    "data-name": "Path 28036",
    d: "M8.752,200.894c-.5.483-.329,1.1-.285,1.662A34.9,34.9,0,0,1,.933,227.165c-.208.272-.679.5-.309.972a16.408,16.408,0,0,0,11.738-14.191,14.158,14.158,0,0,1,0-4.657,14.1,14.1,0,0,0-3.6-8.395",
    transform: "translate(134.047 -122.226)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28037",
    "data-name": "Path 28037",
    d: "M237.5,187.656c-1.618,3.389-3.152,6.821-4.873,10.158-3.634,7.046-7.843,13.707-13.481,19.367a7.874,7.874,0,0,0-.774,1.087,18.058,18.058,0,0,0,4.23-.873,4.783,4.783,0,0,1,.43-.381,75.141,75.141,0,0,0,9.811-13.587,114.329,114.329,0,0,0,6.29-12.573,4.356,4.356,0,0,0,.594-2.816c-.593-1.009-1.365-.963-2.228-.381",
    transform: "translate(-178.71 -113.921)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28038",
    "data-name": "Path 28038",
    d: "M126.178,274.31c-1.494,0-2.624,1.04-3.992,1.418-.5.138-.942.428-1.47.159-1.176,1.87-.769,4.046-1.117,6.07a16.9,16.9,0,0,1-2.972,7.722c-.417.545-1,1.053-.987,1.85,2.162-.141,4.041-1.491,6.245-1.459a5.5,5.5,0,0,0,1.8-2.945c.3-2.744,1.142-5.377,1.66-8.076a9.924,9.924,0,0,1,.905-3.341,1.143,1.143,0,0,0-.068-1.4",
    transform: "translate(-25.134 -166.894)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28039",
    "data-name": "Path 28039",
    d: "M121.342,313.9c-2.392-.625-4.3.647-6.279,1.614-.238,1.382.848,2.06,1.6,2.873.821.889,1.764,1.665,2.654,2.488a18.7,18.7,0,0,0,5.047-1.121c.666-.325,1.468-.543,1.751-1.382a7.057,7.057,0,0,0-4.771-4.472",
    transform: "translate(-24.559 -190.88)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28040",
    "data-name": "Path 28040",
    d: "M200.007,80.167c1.092-5.8.934-11.652.618-17.505-.039-.725-.592-1.528.377-2.064l-3.213-4.332c.969,6.706,1.459,13.418.381,20.167a15.69,15.69,0,0,0,0,2.534c.81.1.98,1.179,1.84,1.2",
    transform: "translate(-131.854 -34.233)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28041",
    "data-name": "Path 28041",
    d: "M155.143,258.55q-.032.213-.064.425c3.872-.393,7.658-1.342,11.558-1.617,5.259-.371,10.516-.65,15.786-.673q6.061-.026,12.121,0a18.028,18.028,0,0,1,2.118.252l.4-.638c-.707-.776-1.662-.646-2.551-.648-7.793-.021-15.589-.142-23.378.04a69.509,69.509,0,0,0-13.875,1.89,9.562,9.562,0,0,0-2.111.975",
    transform: "translate(-111.187 -155.503)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28042",
    "data-name": "Path 28042",
    d: "M148.146,95.481A54.64,54.64,0,0,0,159.1,106.152a.3.3,0,0,0,.116-.316c-.034-.108-.069-.162-.105-.162A87.437,87.437,0,0,1,148.23,94.9a.362.362,0,0,0-.085.585",
    transform: "translate(-70.596 -57.736)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28043",
    "data-name": "Path 28043",
    d: "M132.322,122.42c0,.159-.007.317-.01.477a30.209,30.209,0,0,0,5.886,4.577c.4.2.441-.01.369-.336l-6.245-4.717",
    transform: "translate(-43.809 -74.482)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28044",
    "data-name": "Path 28044",
    d: "M87.221,149.106a5.586,5.586,0,0,0,1.887,2.056,4.3,4.3,0,0,1,2.422-.425,14.444,14.444,0,0,0-4.309-1.631",
    transform: "translate(20.914 -90.718)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28045",
    "data-name": "Path 28045",
    d: "M119.446,134.466l-.369.336c1.751,1.267,3.313,2.821,5.415,3.553a.255.255,0,0,0,.166-.238q-.01-.159-.055-.159l-5.156-3.492",
    transform: "translate(-24.688 -81.811)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28046",
    "data-name": "Path 28046",
    d: "M109.517,143.384l-.11.4a19.018,19.018,0,0,0,3.953,2.417c-.273-.923-1.168-1.186-1.852-1.589-1.335-.786-.081-.8.257-1.1l-2.248-.124",
    transform: "translate(-9.604 -87.237)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28047",
    "data-name": "Path 28047",
    d: "M179.361,89.411l.085-.585A20.14,20.14,0,0,0,176.3,84.92a.353.353,0,0,0-.072.573l3.131,3.919",
    transform: "translate(-101.812 -51.666)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28048",
    "data-name": "Path 28048",
    d: "M140.375,263.325a13.134,13.134,0,0,0-5.031-.529l3.165.916,1.866-.388",
    transform: "translate(-46.775 -159.854)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28049",
    "data-name": "Path 28049",
    d: "M186.883,80.7q.036-.285.072-.572c-.842-1.117-1.269-2.611-2.813-3.088a19.108,19.108,0,0,0,2.741,3.66",
    transform: "translate(-112.464 -46.869)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28050",
    "data-name": "Path 28050",
    d: "M.409,222.332a6.786,6.786,0,0,0,0,4.657,14.168,14.168,0,0,0,0-4.657",
    transform: "translate(145.994 -135.27)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28051",
    "data-name": "Path 28051",
    d: "M100.326,145.206a2.213,2.213,0,0,0,2.688,1.206,6.965,6.965,0,0,0-2.688-1.206",
    transform: "translate(4.299 -88.345)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28052",
    "data-name": "Path 28052",
    d: "M191.2,72.222a2.925,2.925,0,0,0,1.327,1.726,2.071,2.071,0,0,0-1.327-1.726",
    transform: "translate(-120.798 -43.941)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28053",
    "data-name": "Path 28053",
    d: "M277.926,27.7c-1.581-.984-3.368-.809-5.106-.911-1.531-.635-2.816.22-4.044.831a27.094,27.094,0,0,0-8.425,6.573c-8.861,10.231-14.492,22.191-18.52,34.989a94.95,94.95,0,0,0-4.571,22.156c-.431,6.48-.787,13.024,1.078,19.412a16.875,16.875,0,0,0,4.532,8.074,4.154,4.154,0,0,0,1.947,1.243c5.719.378,10.083-2.491,14.118-6.019,4.567-3.994,7.141-9.375,9.8-14.656a77.926,77.926,0,0,0,3.182-7.332A2.964,2.964,0,0,0,272.279,90a2.915,2.915,0,0,0-1.3-1.187c-5.931-3.331-12.025-6.364-17.965-9.679-.986-.41-2.058-.693-2.591-1.769-1.2-2.847-.159-5.507.678-8.18a6.4,6.4,0,0,1,1.093-2.095,5.121,5.121,0,0,0,.31-.435c1.154-1.782,2.671-2.606,4.8-1.82a3.453,3.453,0,0,0,.578.15c6.266,1.539,12.6,2.748,18.893,4.164a3.95,3.95,0,0,0,1.677.023c.92-.243,1.113-1.02,1.268-1.79,1.621-8.029,3.063-16.093,3.022-24.315a32.284,32.284,0,0,0-2.452-12.353,6.091,6.091,0,0,0-2.361-3.01",
    transform: "translate(-228.914 -16.164)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28054",
    "data-name": "Path 28054",
    d: "M266.9,117.2c-2.933-1.592-4.514-4.235-5.6-7.247-2.459-6.8-2.4-13.866-1.728-20.888a112.683,112.683,0,0,1,12.464-41.5c3.719-7.149,8.069-13.873,14.336-19.125a17.838,17.838,0,0,1,8.264-4.222c.856-.653,1.925,0,3.117-.6a10.462,10.462,0,0,0-7.05-1.074c-5.378,1.1-9.349,4.481-12.9,8.308-5.522,5.955-9.587,12.9-13.026,20.239a112.58,112.58,0,0,0-9.3,30.055,73.776,73.776,0,0,0-1.1,15.709c.3,5.558.717,11.154,3.737,16.132,3.187,5.253,7.135,6.95,13.2,5.525.622-.146,1.22-.4,1.83-.6a2.643,2.643,0,0,0-2.556-.569,12.331,12.331,0,0,1-3.684-.146",
    transform: "translate(-250.724 -13.59)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28055",
    "data-name": "Path 28055",
    d: "M229.673,29.465c2.465,3.365,3.369,7.273,3.888,11.3,1.02,7.93-.419,15.684-1.743,23.442-.306,1.794-.7,3.573-1.007,5.366a1.208,1.208,0,0,1-.7,1.076c-.021.388.257.524.548.651a8.685,8.685,0,0,0,2.809.458c.96-.073,1.288-.756,1.474-1.552a83.1,83.1,0,0,0,2.14-13.357c.3-5.915.6-11.83-.994-17.636a20.131,20.131,0,0,0-2.935-6.757c-1.066-1.109-1.846-2.549-3.482-2.993",
    transform: "translate(-180.661 -17.927)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28056",
    "data-name": "Path 28056",
    d: "M255.745,217.967c1.977,1.138,4.15.554,6.24.715a19.028,19.028,0,0,0,5.423-2.7,10.075,10.075,0,0,1,1.6-1.272l-.014.01a51.187,51.187,0,0,0,8.929-10.105c.3-.427.627-.816.95-1.216a25.914,25.914,0,0,1,2-3.2c.829-1.7,1.9-3.274,2.714-4.985a12.951,12.951,0,0,1,1.463-2.821l0,.01a10.514,10.514,0,0,0,.983-2.642c-.607-1.106-1.755-1.371-2.8-1.8a.66.66,0,0,0-.521.165,53.524,53.524,0,0,1-4.261,10.236c-2.38,4.847-4.926,9.636-9,13.366-3.889,3.565-8.25,6.108-13.7,6.24",
    transform: "translate(-239.573 -114.355)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28057",
    "data-name": "Path 28057",
    d: "M208.715,114.917c-.555-.49-.273-2.267-1.841-1.2a140.85,140.85,0,0,1-4.014,18.374c-1.131,3.554-2.336,7.085-3.508,10.626.7.155,1.71-.454,1.95.805.86-.018.869-.8,1.177-1.31a107.624,107.624,0,0,0,6.321-23.675c.132-.933.6-1.9-.006-2.841q-.04-.39-.079-.78",
    transform: "translate(-140.562 -68.983)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28059",
    "data-name": "Path 28059",
    d: "M248.14,179.73c.7.855,1.89.921,2.669,1.651a.632.632,0,0,0,.78-.093l2.452-6.234c.2-.359-.042-.491-.307-.616-2.106-.775-3.365.513-4.593,1.883a3.107,3.107,0,0,0-.488.7c-.251.888-.876,1.707-.513,2.711",
    transform: "translate(-204.643 -105.988)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28061",
    "data-name": "Path 28061",
    d: "M229.05,37.107a38.242,38.242,0,0,1,3.159,8.923,54.937,54.937,0,0,1,.46,15.487c.327.612-.135,1.358.328,1.947.108-.23.31-.459.31-.689.007-6.468.76-12.992-1.125-19.332-.672-2.263-1.149-4.691-3.133-6.335",
    transform: "translate(-176.555 -22.576)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28062",
    "data-name": "Path 28062",
    d: "M236.36,151.858l.41.416a77.258,77.258,0,0,0,4.718-15.293c-.488-.372-1.024-.159-1.545-.126-.357,4.522-1.993,8.7-3.475,12.918a2.549,2.549,0,0,0-.107,2.085",
    transform: "translate(-187.372 -83.209)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28063",
    "data-name": "Path 28063",
    d: "M283,226.958a123.223,123.223,0,0,1-9.689,11.411c2.177-.936,3.471-2.891,5-4.525A39.99,39.99,0,0,0,283.467,227q-.206-.338-.47-.043",
    transform: "translate(-243.892 -138.001)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28064",
    "data-name": "Path 28064",
    d: "M230.343,114.275h1.6a57.174,57.174,0,0,0,2.325-12.884c-.131-.645.215-1.372-.328-1.947a78.562,78.562,0,0,1-2.028,12.936c-.206.9-.491,1.61-1.588,1.54a.213.213,0,0,0-.078.241q.048.115.093.115",
    transform: "translate(-177.832 -60.502)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28065",
    "data-name": "Path 28065",
    d: "M264.117,206.041l-2.763,5.091a.232.232,0,0,0,.4.006,26.44,26.44,0,0,0,2.759-5.084c-.126-.2-.26-.194-.4-.013",
    transform: "translate(-220.26 -125.276)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28066",
    "data-name": "Path 28066",
    d: "M270.79,219.26l-.4-.006a7.9,7.9,0,0,0-1.989,3.1l.47.043,1.922-3.137",
    transform: "translate(-229.292 -133.397)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28067",
    "data-name": "Path 28067",
    d: "M255.991,192.291l-.78.093c.025.954-.905,1.656-.7,2.657.993-.648.993-1.829,1.477-2.75",
    transform: "translate(-209.045 -116.992)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28068",
    "data-name": "Path 28068",
    d: "M258.245,202.015l.4.013a7.206,7.206,0,0,0,1.217-2.74c-1.025.621-1.245,1.719-1.616,2.727",
    transform: "translate(-214.387 -121.249)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28069",
    "data-name": "Path 28069",
    d: "M300.811,256.288a1.74,1.74,0,0,0-1.6,1.271,2.281,2.281,0,0,0,1.6-1.271",
    transform: "translate(-271.38 -155.929)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28071",
    "data-name": "Path 28071",
    d: "M110.351,289.821a24.108,24.108,0,0,1,4.77,4.471c1.055,0,.993-.9,1.086-1.514a73.956,73.956,0,0,0,.453-17.218c-.111-1.368-.958-1.519-2.049-1.343-.042.409.027.851-.349,1.159a19.54,19.54,0,0,0-.634,3.425c-.507,2.78-1.229,5.513-1.842,8.27-.2,1.06-1.439,1.582-1.435,2.751",
    transform: "translate(-13.568 -166.801)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28072",
    "data-name": "Path 28072",
    d: "M102.537,168.33c-.933.989-.133,2.012.047,2.949.856,4.46.179,8.812-.908,13.1A33.682,33.682,0,0,1,90.9,202.044a17.7,17.7,0,0,1-4.753,2.6c-.491.209-.989.324-1.2.876,4.855-1.192,8.387-4.26,11.285-8.131,5.842-7.805,7.953-16.655,7.082-26.277a15.861,15.861,0,0,0-.766-2.785",
    transform: "translate(9.847 -102.414)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28073",
    "data-name": "Path 28073",
    d: "M57.454,268.606c3.923,2,8.1,3.405,12.14,5.131-.9-1.461-2.587-1.567-3.944-2.187-2.686-1.226-5.459-2.26-8.2-3.374a.27.27,0,0,0-.1.286c.032.1.065.143.1.143",
    transform: "translate(54.55 -163.162)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28074",
    "data-name": "Path 28074",
    d: "M107.152,267.885a32.133,32.133,0,0,0,9.073-2.367l-.119-.472c-2.114.577-4.282,1.016-6.318,1.8-.873.335-2.238-.459-2.648,1.023l.011.019",
    transform: "translate(-11.581 -161.257)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28075",
    "data-name": "Path 28075",
    d: "M125.064,378.171c.64.959,1.411.312,2.081.109a19.569,19.569,0,0,1,6.515-1.287q.145-.123.1-.248t-.094-.126l-.786-.442-7.815,1.994",
    transform: "translate(-36.145 -228.871)",
    fill: "#ae3c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28076",
    "data-name": "Path 28076",
    d: "M93.029,266.052c0-.143,0-.285,0-.429-1.461-.816-2.8-2-4.682-1.542a25.242,25.242,0,0,0,4.683,1.97",
    transform: "translate(18.975 -160.608)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28077",
    "data-name": "Path 28077",
    d: "M75.428,377.307q0,.187-.005.374a122.818,122.818,0,0,1,18.522,7.477c.34.177.689.428,1.027-.009-5.676-3.335-11.842-5.526-18.02-7.683a6.594,6.594,0,0,0-1.524-.159",
    transform: "translate(22.092 -229.558)",
    fill: "#a34338"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28078",
    "data-name": "Path 28078",
    d: "M101.962,118.671A137.854,137.854,0,0,1,95.193,145.3a2.153,2.153,0,0,0,1.658.456c2.7-.255,5.284.472,7.921.734,7.124.708,13.648,3.249,20.095,6.07a96.6,96.6,0,0,1,13.255,7.094,1.23,1.23,0,0,0,1.447.176,29.073,29.073,0,0,0,3.469-11.331c.09-1.042-.239-1.5-1.408-1.275a4.92,4.92,0,0,1-3.175-.655c-3.827-1.909-7.779-3.585-11.523-5.641a56,56,0,0,1-8.807-6.656c-1-.842-2.128-1.481-3.118-2.312-4.684-3.93-8.45-8.71-12.278-13.422-.574-.706-.506.193-.768.129",
    transform: "translate(-33.73 -71.957)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28079",
    "data-name": "Path 28079",
    d: "M165.97,201.357c-2.732-1.565-5.422-3.207-8.2-4.679a110.782,110.782,0,0,0-19.631-7.979c-3.695-1.126-7.525-1.015-11.225-2-1.562-.418-3.534.023-5.317.13l-.723,1.195a96.966,96.966,0,0,1-10.1,19.683c-2.02,3.1-4.423,5.908-6.681,8.825,4.622-.973,9.29-1.662,13.978-2.217a8.264,8.264,0,0,1,.972-.076q13.483.014,26.966.037c3.661-.042,7.4.627,10.751-1.655a26.1,26.1,0,0,0,9.217-11.261",
    transform: "translate(-60.131 -113.48)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28080",
    "data-name": "Path 28080",
    d: "M118.464,294.216a26.573,26.573,0,0,0,1.993-8.178c-.118-.188-.235-.178-.349,0-.751,2.684-1.7,5.328-1.644,8.174",
    transform: "translate(-20.246 -173.946)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28081",
    "data-name": "Path 28081",
    d: "M117.2,280.791q.174,0,.348,0a14.059,14.059,0,0,0,.484-3.517,5.675,5.675,0,0,0-.832,3.521",
    transform: "translate(-17.341 -168.695)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28082",
    "data-name": "Path 28082",
    d: "M269.294,127.8c-6.341-1.526-12.694-3-19.127-4.089-.02.061-.072.134-.055.181,1.359,3.848.2,7.422-1.191,10.971a1.706,1.706,0,0,0,1.274,1.555c5.181,2.082,10.258,4.416,15.466,6.434a2.15,2.15,0,0,0,1.334.149,1.95,1.95,0,0,0,1.126-1.467c.808-2.771,1.778-5.5,2.364-8.33.4-1.976-.658-3.632-1.191-5.4",
    transform: "translate(-221.449 -75.267)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28083",
    "data-name": "Path 28083",
    d: "M279.151,160.177q-8.4-3.434-16.807-6.87a1.112,1.112,0,0,1-.838-.965c-1.4,1.128-2.675,2.389-4,3.6,1.956,1.525,4.279,2.395,6.427,3.575,3.853,2.117,7.777,4.1,11.672,6.146A3.74,3.74,0,0,0,278,163.715l.379-.421c.384-.861,1.145-1.57,1.056-2.622a1.145,1.145,0,0,0-.282-.5",
    transform: "translate(-233.677 -92.686)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28084",
    "data-name": "Path 28084",
    d: "M300.412,127.364c-1.117,2.907-2.221,5.815-.7,8.929,2.248,1.806,3.265,1.914,5.043-.32,2.472-3.106,3.986-6.643,3.016-10.791a2.839,2.839,0,0,0-1.18-1.928c-2.429-1.076-3.621.679-4.933,2.157l.011-.014c-.448.638-.6,1.463-1.259,1.966",
    transform: "translate(-278.544 -74.787)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28085",
    "data-name": "Path 28085",
    d: "M304.9,123.613a3.881,3.881,0,0,1,1.452,3.641,13.945,13.945,0,0,1-2.742,7.977c-1.95,2.523-2.555,2.605-5.4,1.208.426,1.28,1.539,1.516,2.656,1.745a6.712,6.712,0,0,0,4-3.6,31.841,31.841,0,0,0,1.694-4.689,8.605,8.605,0,0,0-.808-6.523l-.462-.163c-.419-.15-.489.045-.4.4",
    transform: "translate(-277.041 -74.933)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28086",
    "data-name": "Path 28086",
    d: "M247.192,134.153c-.921.184-.539.743-.25,1.122a5.96,5.96,0,0,1,1.014,4.04.4.4,0,0,0,.557-.109c.388-1.5,1.277-2.922.641-4.563l-.354-.3-1.607-.192",
    transform: "translate(-199.348 -81.62)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28087",
    "data-name": "Path 28087",
    d: "M263.584,181.389a10.64,10.64,0,0,0-2.395,1.941l1.207.8a1.4,1.4,0,0,1,.364-.029,8.514,8.514,0,0,0,.824-2.712",
    transform: "translate(-219.263 -110.359)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28088",
    "data-name": "Path 28088",
    d: "M306.959,123.1l.4-.4c-2.305-.923-3.912-.19-5.138,2.344a20.837,20.837,0,0,1,2.392-1.851,2.061,2.061,0,0,1,2.35-.093",
    transform: "translate(-279.1 -74.417)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28089",
    "data-name": "Path 28089",
    d: "M315.31,131.21c.938-.323,1.153-1.11,1.259-1.966a2.837,2.837,0,0,0-1.259,1.966",
    transform: "translate(-293.441 -78.634)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28090",
    "data-name": "Path 28090",
    d: "M244.359,135.329c-.188,1.569-.96,3.036-.812,4.663-.069,1.234.267,2.435.273,3.671.014,2.941-.772,5.366-3.78,6.534-.128.945-.946,1.69-.787,2.718,1.245-1.057,2.354-2.411,4.289-1.959,1.214-3.959,2.833-7.789,3.754-11.842a4.151,4.151,0,0,0-.231-3.034c-.005-.119-.01-.238-.014-.356-.911-.034-1.743-.609-2.691-.394",
    transform: "translate(-194.552 -82.307)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28091",
    "data-name": "Path 28091",
    d: "M246.982,157.516c2.358.3,3.221-1.356,3.79-3.109a8.752,8.752,0,0,0-.283-7.1q-.193,0-.386.009-1.2,4.24-2.4,8.48a2.365,2.365,0,0,1-.736,1.316c0,.133.009.267.013.4",
    transform: "translate(-201.494 -89.625)",
    fill: "#871f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28092",
    "data-name": "Path 28092",
    d: "M304.182,136.178c.016,1.414.142,2.383,1.061,2.812a1.918,1.918,0,0,0,2.38-.84,7.243,7.243,0,0,0,1.542-5.8c-.414-1.907-1.585-2.223-3.017-.833s-1.554,3.329-1.966,4.662",
    transform: "translate(-281.816 -79.494)",
    fill: "#871f20"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/Megaphone.2faafdcace834e1c9c9e3bb33a7c17a3.svg";
export { ForwardRef as ReactComponent };